import request from '@/utils/httpRequest'
// 获取筛选栏 状态、结果列表
export function getDictByCode(query) {
    query = { codeTypes: query };
    return request({
        url: request.adornUrl('/config/dict/get-dict-by-code-types'),
        method: "post",
        headers: {},
        params: query
    })

}


// WEBPACK FOOTER //
// ./src/api/home/home.js